export default __webpack_public_path__ + "static/media/m_wdt_c_2.c8ad83bf.mp3";